import React from 'react';
import { AttachmentContainer, FileIcon, FileName } from './styles';
import { ReactComponent as DownloadIcon } from '../../svg/download.svg';
import { ReactComponent as CsvIcon } from '../../svg/file-csv.svg';
import { useTheme } from 'styled-components';
import utils from 'utils';

interface AttachmentProps {
  contentType: string;
  fileBase64: string;
  filename: string;
}

export const Attachment: React.FC<AttachmentProps> = ({ contentType, fileBase64, filename }) => {
  const theme = useTheme();

  const handleDownload = () => {
    try {
      utils.file.downloadFileFromBase64Source(filename, fileBase64, contentType);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <AttachmentContainer onClick={handleDownload}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <FileIcon>
          <CsvIcon />
        </FileIcon>
        <FileName>{filename}</FileName>
      </div>

      <DownloadIcon color={theme.colorPalette.grey.grey6} />
    </AttachmentContainer>
  );
};
